import { Component, EventEmitter, OnChanges, Output } from '@angular/core';
import { BusinessParticularityOption } from '../options.component';
import { BusinessParticularities } from '@shared-logic/business-particularities';

@Component({
  selector: 'app-contrato-fason',
  templateUrl: './contrato-fason.component.html',
  styleUrls: ['./../options.component.scss', './../../../fields.component.scss']
})
export class ContratoFasonComponent extends BusinessParticularityOption implements OnChanges {
  isContractFason: boolean = false;
  //@Output() save = new EventEmitter<string>();

  constructor() {
    super()
  }

  ngOnChanges(): void {
    this.isContractFason = this.businessParticularitiesStruct?.isFasonContract ?? false;
  }

  setIsContractFason() {
    this.isContractFason = !this.isContractFason;
    let newBP: BusinessParticularities = JSON.parse(JSON.stringify(this.businessParticularitiesStruct))
    newBP.isFasonContract = this.isContractFason;
    this.save.emit(JSON.stringify(newBP));
  }
}
